import React from "react";
import { RatingReviewSmallCardView } from "./view";
import { styles } from "./styles";

export const RatingReviewSmallCard = props => (
  <RatingReviewSmallCardView {...props} styles={styles} />
);
